import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/browser'

const windowIsDefined = typeof window !== 'undefined'

const env = windowIsDefined && window?.__BL_ANALYTICS__?.environment
const release = windowIsDefined && window?.__BL_ANALYTICS__?.app_version

export const startSentry = () => {
  if (windowIsDefined) {
    Sentry.init({
      dsn: 'https://5ce88c302ad84037b02be55edebe6500@o1363869.ingest.sentry.io/4505189536497664',
      environment: env,
      initialScope: (scope) => {
        scope.setTag('application', 'babylist-health')
        return scope
      },
      integrations: [new BrowserTracing()],
      release,
      tracesSampler: () => {
        if (env === 'staging') {
          return 1
        }

        if (env === 'production') {
          return 0.5
        }

        return 0
      },
    })
  }
}
